module.exports = __webpack_public_path__ + "static/media/bitmap_bg_white.342dbfc2.png";